<template>
  <v-card class="rounded-card card-shadow" color="primary">
    <v-card-title class="white--text font-weight-bold">
      <v-icon x-large left color="white">mdi-chart-donut</v-icon>
      Totais
    </v-card-title>
    <v-card-text v-if="!loading && !totais"
                 class="text--primary dashboard-empty-div d-flex align-center justify-center">
      <span class="white--text font-weight-bold">
        Nenhum dado encontrado para o período
      </span>
    </v-card-text>
    <v-card-text v-else
                 :style="{height: cardHeight}"
                 class="text--primary">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div v-if="!loading && totais"
           class="d-flex flex-column justify-space-around fill-height">
        <div class="d-flex justify-space-around">
          <div class="text-center">
          <span class="white--text headline font-weight-bold">
            {{ totais.totalComprado | currency }}
          </span>
            <div class="white--text body-2">
              total comprado
            </div>
          </div>
        </div>
        <div class="d-flex justify-space-between align-center mx-12 mt-8">
          <div class="white--text body-1">
            Saving
          </div>
          <div class="white--text headline font-weight-bold">
            {{ totais.savingTotal | currency }}
          </div>
        </div>
        <div class="d-flex flex-column">
          <v-divider class="white"/>
          <div class="d-flex justify-space-between align-center mt-4 mx-12">
            <div class="white--text">
              <h3>Saving perc.</h3>
            </div>
            <div class="white--text headline font-weight-bold">
              {{ percentualSaving | number('0.0') }}%
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import IndicadoresService from '@/modules/dashboard/dashboard-service';
import currency from 'currency.js';

export default {
  props: {
    stringFilter: String,
    tipoProduto: String,
    cardHeight: {
      type: String,
      default: '260px',
    },
  },
  data() {
    return {
      totais: null,
      loading: false,
    };
  },
  computed: {
    percentualSaving() {
      if (!this.totais || !this.totais.savingTotal || !this.totais.totalComprado) {
        return 0;
      }
      return currency(this.totais.savingTotal).multiply(100)
        .divide(currency(this.totais.totalComprado).add(this.totais.savingTotal))
        .value;
    },
  },
  methods: {
    getTotais() {
      this.loading = true;
      IndicadoresService.getComprasTotais({
        filter: this.stringFilter,
        tipoProduto: this.tipoProduto || undefined,
      })
        .then(({ data }) => {
          this.totais = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getTotais();
  },
  watch: {
    stringFilter(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getTotais();
    },
    tipoProduto(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getTotais();
    },
  },
};
</script>

<style scoped>
.dashboard-empty-div {
  height: 280px;
}
</style>
